export const filterEvents = (
  events,
  work,
  mappedHolidays,
  mappedBirthdays,
  searchTerm,
  mapEventsForCalendar
) => {
  const allEvents = [
    ...mapEventsForCalendar(events, "event"),
    ...mapEventsForCalendar(work, "work"),
    ...mappedHolidays,
    ...mappedBirthdays,
  ];

  if (!searchTerm) return allEvents;

  const term = searchTerm.toLowerCase();

  return allEvents.filter((event) => {
    const values = [
      event.title,
      ...(event.extendedProps ? Object.values(event.extendedProps) : []),
    ]
      .filter(Boolean)
      .map((v) => String(v).toLowerCase());

    return values.some((v) => v.includes(term));
  });
};